import { render, staticRenderFns } from "./BatchDialog.vue?vue&type=template&id=90f1e2be&scoped=true"
import script from "./BatchDialog.vue?vue&type=script&lang=js"
export * from "./BatchDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchDialog.vue?vue&type=style&index=0&id=90f1e2be&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f1e2be",
  null
  
)

export default component.exports